import { gql } from "@apollo/client";
export default gql`
    mutation AddGroupTagMap($objects: [group_tag_map_insert_input!]!) {
        addGroupTagMap: insert_group_tag_map(objects: $objects) {
            affected_rows
        }
    }
`;
